import { useEffect, useState } from "react";
import { api, errorMessage } from "../lib/api";

const LABELS = {
  dimension: { branches_3: "3+ sedi", branches_2: "2 sedi", reviews_1000: "1000+ recensioni",
    reviews_400: "400+ recensioni", reviews_150: "150+ recensioni", shifts_12: "12+ turni", price_moderate: "Prezzo moderato+" },
  marketing: { ads_active: "Meta attive ora", ads_recent: "Meta ultimi 90 gg", website: "Sito proprio", social_2: "2+ social", social_1: "1 social" },
  organization: { reservable: "Prenotabile", delivery: "Delivery", takeout: "Asporto", lunch_dinner: "Pranzo e cena" },
  sector: { A: "A · Cucina", B: "B · Artigianale", C: "C · Collettiva", D: "D · Bar", E: "E · Alimentare", F: "F · Ospitalità" },
  penalties: { rating_low: "Google sotto 3,8", reviews_low: "Meno di 50 recensioni" },
  caps: { dimension: "Dimensione", marketing: "Marketing", organization: "Organizzazione", sector: "Settore" },
};
const SECTIONS = [ ["dimension", "DIMENSIONE · MAX 1,5"], ["marketing", "INVESTE NEL MARKETING · MAX 1,5"],
  ["organization", "ORGANIZZAZIONE · MAX 1,0"], ["sector", "SETTORE · MAX 1,0"],
  ["penalties", "PENALITÀ"] ];

export const ScoreSettings = ({ session, onBack }) => {
  const [weights, setWeights] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [progress, setProgress] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  useEffect(() => { api.get("/map/score-weights").then(({ data }) => setWeights(data.weights))
    .catch((e) => setError(errorMessage(e))); }, []);
  useEffect(() => {
    if (!jobId) return undefined;
    const check = () => api.get(`/scores/recalculate/${jobId}`).then(({ data }) => {
      setProgress(data); if (["completed", "failed"].includes(data.status)) setJobId(null);
    }).catch((e) => setError(errorMessage(e)));
    check(); const timer = setInterval(check, 4000); return () => clearInterval(timer);
  }, [jobId]);
  const edit = (section, key, value) => { setWeights((old) => ({ ...old, [section]: {
    ...old[section], [key]: value === "" ? "" : Number(value) } })); setSaved(false); };
  const save = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try { const { data } = await api.put("/map/score-weights", weights,
      { headers: { "X-CSRF-Token": session.csrf_token } });
      setWeights(data.weights); setJobId(data.recalculation_id); setSaved(true); }
    catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  const recalculate = async () => {
    setBusy(true); setError("");
    try { const { data } = await api.post("/scores/recalculate", {},
      { headers: { "X-CSRF-Token": session.csrf_token } }); setJobId(data.job_id); }
    catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <form className="score-settings" onSubmit={save} data-testid="score-settings-form">
    <button type="button" className="sheet-back" onClick={onBack} data-testid="score-settings-back">‹ Profilo</button>
    <h2 className="sheet-title" data-testid="score-settings-title">VOTO EL SABUESO</h2>
    {weights && SECTIONS.map(([section, title]) => <section key={section} className="score-setting-section">
      <h3 className="section-label" data-testid={`score-section-${section}`}>{title}</h3>
      {Object.entries(LABELS[section]).map(([key, label]) => <label className="score-setting-row" key={key}>
        <span>{label}</span><input type="number" min="0" max={section === "caps" ? "5" : "2"} step="0.01" required
          value={weights[section][key]} onChange={(e) => edit(section, key, e.target.value)}
          data-testid={`score-weight-${section}-${key}`} /></label>)}</section>)}
    {error && <p role="alert" className="form-error" data-testid="score-settings-error">{error}</p>}
    {saved && <p role="status" className="venue-success" data-testid="score-settings-saved">Pesi salvati.</p>}
    {progress && <p role="status" className="score-progress" data-testid="score-recalculation-status">Ricalcolo: {progress.status} · {progress.updated} locali · {progress.apify_calls} controlli Meta{progress.errors ? ` · ${progress.errors} non riusciti` : ""}</p>}
    <button type="submit" className="hud-button" disabled={busy || !weights} data-testid="score-settings-save">Salva e ricalcola</button>
    <button type="button" className="hud-button hud-secondary" disabled={busy || !!jobId}
      onClick={recalculate} data-testid="score-settings-recalculate">Ricalcola i locali presenti</button>
  </form>;
};